module.exports = __webpack_public_path__ + "static/media/pastOrder.c03b18ec.svg";